import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import classes from "./AddPublisherModal.module.css";
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from 'primereact/floatlabel';
import { useDispatch, useSelector } from 'react-redux';
import { removeToken } from '../store/slices/tokenSlice';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Spinner from './Spinner';
import { addPublisherApi } from '../http/http';

const AddPublisherModal = ({ publisherModal, setPublisherModal, handleServiceClick }) => {
    const [publisherName, setPublisherName] = useState("");
    const [amount, setAmount] = useState("");
    const [serviceUrl, setServiceUrl] = useState("");
    const [postbackUrl, setPostbackUrl] = useState("");
    const [dailyCap, setDailyCap] = useState("");
    const [skip, setSkip] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { token } = useSelector(state => state?.tokenSlice);

    useEffect(() => {
        if (publisherModal) {
            setPublisherName("");
            setAmount("");
            setServiceUrl("");
            setPostbackUrl("");
            setDailyCap("");
            setSkip("");
        }
    }, [publisherModal]);

    const addPublisher = async () => {
        try {
            if (publisherName?.trim().length == 0 || amount?.trim().length == 0 || serviceUrl?.trim().length == 0 || postbackUrl?.trim().length == 0 || dailyCap?.trim().length == 0 || skip?.trim().length == 0) {
                return;
            }
            if (!serviceUrl.endsWith("ext_id=<ext_id>")) {
                toast.error("Service Url must include 'ext_id=<ext_id>'")
                return;
            }
            // if (!postbackUrl.endsWith("click_id=<ext_id>")) {
            //     toast.error("Postbake Url must include 'click_id=<ext_id>'")
            //     return;
            // }
            setLoading(true);
            setPublisherModal({
                state: false,
                serviceDetails: null
            })
            let data = {
                service_id: publisherModal?.serviceDetails?.id,
                publisher_name: publisherName, service_url: serviceUrl, postback_url: postbackUrl, daily_cap: dailyCap, amount: amount, skip_value: skip
            }
            await addPublisherApi(data,token);
            await handleServiceClick(publisherModal?.serviceDetails);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.message || "Something Went Wrong!");
            }
        }
    }

    return (
        <Dialog header="Add Publisher" headerStyle={{ fontFamily: "Ubuntu" }} position='bottom' visible={publisherModal?.state} style={{ width: "350px" }} onHide={() => { if (!publisherModal?.state) return; setPublisherModal({ state: false, serviceDetails: null }); }}>
            <h3 className={classes.serviceDetails}>Service: {publisherModal?.serviceDetails?.service_name} ({publisherModal?.serviceDetails?.country}, {publisherModal?.serviceDetails?.operator})</h3>
            <div className={classes.container}>
                <InputText type="text" value={publisherName} onChange={(e) => setPublisherName(e.target.value)} className={` ${classes.input}`} placeholder="Publisher Name" />
                <InputText type="text" value={amount} onChange={(e) => setAmount(e.target.value)} className={` ${classes.input}`} placeholder="Amount Per Subscription" keyfilter={"int"} maxLength={5} />
                <div className="flex flex-column gap-4">
                    <InputText type="text"
                        value={serviceUrl} onChange={(e) => setServiceUrl(e.target.value)} invalid={serviceUrl?.length > 0 && !serviceUrl.endsWith("ext_id=<ext_id>")} className={` ${classes.input}`} placeholder="Service Url" />
                    <small id="username-help">
                        {`Sample: http://optin.telkomsdp.co.za/service/53?cid=700504&ext_id=<ext_id>`}
                    </small>
                </div>
                <div className="flex flex-column gap-4">
                    <InputText type="text" value={postbackUrl}
                        onChange={(e) => setPostbackUrl(e.target.value)} className={` ${classes.input}`} placeholder="Postback Url" />
                    <small id="username-help">
                        {`Sample: https://bmd.go2oh.net/postback?click_id=<ext_id>`}
                    </small>
                </div>
                <InputText type="text" value={dailyCap} onChange={(e) => setDailyCap(e.target.value)} className={` ${classes.input}`} placeholder="Daily Cap" keyfilter={"int"} maxLength={4} />
                <InputText type="text" value={skip} onChange={(e) => setSkip(e.target.value)} className={` ${classes.input}`} placeholder="Skip" keyfilter={"int"} maxLength={3} />
                <div className={classes.center_btn}>
                    <button type='button' className={classes.add_btn} onClick={addPublisher} disabled={loading} >
                        {loading ? "Adding..." : "Add"}
                    </button>
                </div>
            </div>
        </Dialog>
    )
}

export default AddPublisherModal